<template>
  <div id="invoice-container">
    <iframe
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/team/invoice/${$route.params.id}`"
      allow="clipboard-read; clipboard-write"
    />
    <Payment
      :invoice="invoice"
      :balance="balance"
      @onPayInvoice="() => sendMessage('refetch')"
    />
  </div>
</template>

<script>
import Payment from './Payment.vue'

export default {
  components: { Payment },
  data() {
    return {
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      height: 0,
      invoice: {
        invoice_code: '',
        total_admin_fee: 0,
        total_salary_talent: 0,
        total_tax: 0,
        total_additional_cost: 0,
        ppn_numerator: 0,
        admin_service: 0,
        total_nominal: 0,
      },
      balance: {
        ideal_balance: 0,
        ongkir_retur_potential: 0,
        income_order_potential: 0,
        ongkir_retur_on_finished: 0,
        ongkir_risk_become_retur: 0,
        on_withdrawl: 0,
      },
    }
  },
  mounted() {
    window.addEventListener('message', this.watchIframe)
  },
  destroyed() {
    window.removeEventListener('message', this.watchIframe)
  },
  methods: {
    watchIframe(event) {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const { type, data, route } = event.data

        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }

        if (type === 'ERR_DOWNLOAD_INVOICE') {
          this.$toast_error({ message: 'Gagal mengunduh data invoice' })
        }

        if (type === 'PAY_INVOICE') {
          this.invoice = data.invoice
          this.balance = data.balance
          this.$bvModal.show(data.is_evaluated ? 'pay-invoice' : 'evaluation-starter')
        }

        if (route) {
          this.$router.replace(route)
        }
      }
    },
    sendMessage(param) {
      const message = {
        refetch: { type: 'REFETCH_GET_INVOICE_BY_ID' },
      }
      const iframe = document.querySelector('#invoice-container iframe')
      iframe.contentWindow.postMessage(message[param], '*')
    },
  },
}
</script>
